import type { BoxProps } from '../../Box/Box';
import { Box } from '../../Box/Box';

import { cell } from './styles.css';
export interface Props extends Omit<BoxProps, 'display' | 'flexDirection' | 'gap' | 'cssClass'> {
  children?: React.ReactNode;
  icon?: React.ReactNode;
  supressHoverState?: boolean;
}

export const Cell: React.FC<Props> = ({ children, icon, supressHoverState, ...boxProps }) => (
  <Box
    display="flex"
    flexDirection="row"
    alignItems="center"
    cursor={boxProps.onClick ? 'pointer' : undefined}
    gap="6"
    cssClass={supressHoverState ? undefined : cell}
    borderRadius="6"
    p="8"
    {...boxProps}
  >
    {icon && (
      <Box as="span" display="inline-flex">
        {icon}
      </Box>
    )}
    {children}
  </Box>
);
